const maskZipcode = value => {
  if (!value) return { maskedZipCode: '', unmaskedZipCode: '' }
  const removeAllLettersRegex = /\D/g
  const setZipCodeMaskRegex = /(\d{5})(\d{1})/g

  const unmaskedZipCode = value.replace(removeAllLettersRegex, '')
  const zipCode = unmaskedZipCode.substring(0, 8)

  return { maskedZipCode: zipCode.replace(setZipCodeMaskRegex, '$1-$2'), unmaskedZipCode }
}

export { maskZipcode }
